import React from 'react';

function Logo() {
    return <a href="https://www.uhm.com"><div class="logo" /></a>
}

export default Logo;